<template>
  <div id="basketball_course_detail_outer" v-if="trainData != null">
    <img v-if="currentBanner != null" id="match_top_img" :src="currentBanner.url">

    <div class="container" style="text-align: center;margin-top: 30px;">
      <div id="detail_top_title">{{trainData.title}}</div>
      <div id="detail_top_desc">{{subTitle}}</div>
    </div>

    <div class="container" style="padding-bottom: 50px;">
      <div id="top_menu">
<!--        <a v-for="(item, index) in menuList" :key="'train_menu_item_' + index"></a>-->
        <a :class="[ {'active': (tabIndex == 0)} ]" href="javascript:void(null);" @click="topMenuClicked(0)"><span class="iconfont">&#xe721;</span>课程概述</a>
        <a :class="[ {'active': (tabIndex == 1)} ]" href="javascript:void(null);" @click="topMenuClicked(1)"><span class="iconfont">&#xe6d0;</span>课程特色及安排</a>
        <a :class="[ {'active': (tabIndex == 2)} ]" href="javascript:void(null);" @click="topMenuClicked(2)"><span class="iconfont">&#xe659;</span>报名须知</a>
      </div>

      <div v-if="tabIndex == 0" class="rich-content" v-html="trainData.description">
      </div>

<!--     扩展一个字段 -->
      <div v-else-if="tabIndex == 1" class="rich-content" v-html="trainData.feature"></div>
      <div v-else id="course_application_note">
        <course-pay-entry v-bind:item-data="trainData"
                          v-on:paySuccess="userPaySuccess"
                          v-on:updateCurrentOrder="saveCurrentOrder"
                          v-on:userSubmitSuccess="trainApplicationSuccess" ></course-pay-entry>
      </div>
    </div>
  </div>
</template>

<script>
  import CoursePayEntry from "../components/course/CoursePayEntry";
  import WeixinManager from "../js/weixin.config";
export default {
  name: "TrainingCourseDetailPage",
  components: {
    CoursePayEntry,
  },

  data () {
    return {
      tabIndex: 0,
      isLogined: false,
      trainData: null,
      currentOrder: null,
      settedWechat: false,
      menuList: [
        '课程概述',
        '课程特色及安排',
        '报名须知'
      ],
    }
  },

  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    index() {
      return this.$route.params.index;
    },

    summary() {
      let trainData = this.trainData;
      if (trainData == null) {
        return '暂无';
      }
      let h5Url = trainData.h5Url;
      if (h5Url == null) {
        return '暂无';
      }
      return h5Url;
    },

    subTitle() {
      let trainData = this.trainData;
      if (trainData == null) {
        return '';
      }
      let startTime = trainData.regStartTime;
      let endTime = trainData.regEndTime;
      let startDate = this.$moment(startTime).format('YYYY年MM月DD日');
      let endDate = this.$moment(endTime).format('YYYY年MM月DD日');
      return `开课日期：${startDate}-${endDate}`;
    },

    trainingId() {
      return this.$route.params.courseId;
    },
    banners() {
      return this.$store.state.banners;
    },
    currentBanner() {
      if (this.banners == null) {
        return null;
      }
      let item = this.banners.find(function (item) {
        return  item.name == 'training';
      });

      if (item == undefined) {
        return null;
      }
      return item;
    },
  },
  mounted() {
    let index = this.index;
    if (index != undefined) {
      if (this.isLogined) {
        this.tabIndex = 2;
      }
    }

    let query = this.$route.query;
    let state = query.state;
    // console.log(query);
    if (state == this.weichatAutoState.pay || state == this.weichatAutoState.login || state == 1001) {
      this.tabIndex = 2;
    }
    this.loadData();
  },
  methods: {

    saveCurrentOrder(res) {
      let currentOrder = res.current;
      this.currentOrder = currentOrder;
    },

    dealWithShareObj() {
      if (this.settedWechat) {
        return;
      }
      this.settedWechat = true;
      let shareObj = this.$store.state.http.defaultShareObj;
      shareObj.title = this.trainData.title;
      shareObj.link = location.href;
      this.configShareWx(encodeURIComponent(location.href), shareObj);
    },

    userPaySuccess() {
      this.loadData();
    },

    trainApplicationSuccess() {
    },

    loadData() {
      let trainingId = this.trainingId;
      let params = {
        trainingId
      };
      let _this = this;
      this.httpManager.ajax.getVmTrainingGetData(params, function (data) {
        // console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.trainData = data.data;
          _this.dealWithShareObj();
          return;
        }
      }, function (data) {

      });
    },

    topMenuClicked(index) {
      this.tabIndex = index
    }
  }
}
</script>

<style scoped>

  #basketball_course_detail_outer {
    width: 100vw;
  }

  #basketball_course_detail_outer #match_top_img {
    width: 100%;
    height: auto;
  }

  #basketball_course_detail_outer #top_menu {
    padding-top: 15px;
    padding-bottom: 15px;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
  }

  #basketball_course_detail_outer #top_menu > a {
    margin-left: 15px;
    margin-top: 15px;
  }

  @media screen and (min-width: 768px) {
    #basketball_course_detail_outer #top_menu {
      justify-content: center;
    }
    #basketball_course_detail_outer #top_menu > a {
      margin-left: 30px;
      margin-top: 15px;
    }
  }



  #basketball_course_detail_outer #top_menu > a {
    color: #333;
    font-size: 1.5rem;
    font-weight: bold;
    text-decoration: none;
  }

  #basketball_course_detail_outer #top_menu > a > span {
    margin-right: 8px;
    font-size: inherit;
  }

  #basketball_course_detail_outer #top_menu > a.active {
    color: #fc1a34;
    pointer-events: none;
  }

  /*#basketball_course_detail_outer #course_summary {*/
  /*  box-shadow: 0 0 15px rgba(255,0,0, 0.15);*/
  /*  height: 150px;*/
  /*  margin-top: 15px;*/
  /*  padding: 15px;*/
  /*}*/


  #basketball_course_detail_outer .rich-content {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    /*height: 150px;*/
    margin-top: 15px;
    padding: 15px;
    width: 100%;

    overflow-x: auto;
  }

  #basketball_course_detail_outer .rich-content /deep/ table {
    width: auto;
    max-width: 100%;
  }

  #basketball_course_detail_outer .rich-content /deep/ section table {
    border: solid 1px #333;
    background-color: #000;
  }

  #basketball_course_detail_outer .rich-content /deep/ section table td, #basketball_course_detail_outer .rich-content /deep/ section table th  {
    background-color: white;
    border: none;
  }

  #basketball_course_detail_outer #course_application_note {
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    margin-top: 15px;
    padding: 15px;
  }

  #detail_top_title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
  }

  #detail_top_desc {
    font-size: 1rem;
    color: #999;
    margin-top: 10px;
  }


</style>



// WEBPACK FOOTER //
// src/pages/TrainingCourseDetailPage.vue